<script setup lang="ts">

</script>

<template>
  <svg class="offer-exchange-cursor" viewBox="0 0 201 250" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <g filter="url(#filter0_d)">
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M152 106.927L33.9426 25.052L45.9804 168L86.7482 116.307L152 106.927Z" fill="white"/>
    </g>
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M41.9824 38.9106L51.3539 150.197L83.0921 109.954L133.892 102.652L41.9824 38.9106Z" fill="#212243"/>
    <path d="M18.9063 68.6033L11.9006 73.4982" stroke="#0C39FF" stroke-width="6" stroke-linecap="round"/>
    <path d="M54.3713 7.36499L52.8779 15.8051" stroke="#0C39FF" stroke-width="6" stroke-linecap="round"/>
    <path d="M22.4285 13.9905L27.3301 20.9865" stroke="#0C39FF" stroke-width="6" stroke-linecap="round"/>
    <path d="M5.25977 41.6709L13.7118 43.1623" stroke="#0C39FF" stroke-width="6" stroke-linecap="round"/>
    <path d="M82.0171 24.5044L75.0115 29.3993" stroke="#0C39FF" stroke-width="6" stroke-linecap="round"/>
    <defs>
      <filter id="filter0_d" x="2.94263" y="25.052" width="198.058" height="224.948"
              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0"/>
        <feColorMatrix in="SourceAlpha" type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset dx="9" dy="42"/>
        <feGaussianBlur stdDeviation="20"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.173 0 0 0 0 0.178 0 0 0 0 0.279 0 0 0 0.12 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic"/>
      </filter>
    </defs>
  </svg>
</template>

<style scoped lang="scss">

/* SVG: absolute + плавное смещение */
.offer-exchange-cursor {
  position: absolute;
  right: var(--art-right); /* ← флюидный отступ вправо (отрицательный = «заезд») */
  top: var(--art-top);
  transform: translateY(-50%);
  z-index: -1;

  width: var(--art-w);

  /* Скрыт по умолчанию, появится после анимации текста */
  opacity: 0;
  visibility: hidden;

  /* Плавность при ресайзе/переключении брейкпоинтов */
  transition: right 400ms ease,
  top 400ms ease,
  width 400ms ease,
  height 400ms ease,
  opacity 500ms ease,
  visibility 0ms ease 500ms;
  /* transform не включен в transition, чтобы не конфликтовать с animation */

  /* Плавное появление - начинается под конец анимации h1 и p (~1000ms) */
  animation:
    cursorAppear 400ms ease forwards 1300ms,
    artDrift 6s ease-in-out infinite alternate 1400ms;

}

@keyframes cursorAppear {
  from {
    opacity: 0;
    visibility: hidden;
  }
  to {
    opacity: 1;
    visibility: visible;
  }
}

/* (опционально) лёгкий автодрифт, чтобы было «живее» */
@media (prefers-reduced-motion: no-preference) {
  .offer-exchange-cursor {
    /* artDrift уже включен в основную animation выше */
  }
}

@keyframes artDrift {
  from {
    transform: translateY(-50%) translate(0, 0);
  }
  to {
    transform: translateY(-50%) translate(-0.4rem, 0.4rem);
  }
  /* чуть-чуть влево и вниз */
}
</style>